module.exports = __webpack_public_path__ + "img/quicksilver_amulet.c4550448.png";